<template>
  <b-container>
    <div class="mt-4 d-flex justify-content-between">
      <back-arrow :bilan-type="bilanType"
                  :params="{operationId: operationId}"
                  :sub-title-ope="operationName"
                  :title="$t('Devis')"
                  route-back="OperationShow"/>

      <b-card :class="`bilan-${(bilanType ? bilanType :  '').toLowerCase()}`" class="backtotal ml-auto col-md-2">
        <div class="bold-text">
          {{ $t('devis.totalttc') }}
        </div>
        <div class="level-one-title ml-auto text-right">
          {{ totalTTC | formatEuro }}
        </div>
      </b-card>
    </div>

    <b-card class="mt-2 mb-4 shadow-sm">
      <div class="row w-100 align-items-center mb-2">
      </div>
      <b122-table
        ref="B122TableDevis"
        :create-item="false"
        :empty-text="$t('devis.emptyText').toString()"
        :empty-title="$t('devis.emptyTitle').toString()"
        :fields="tableFieldsDevis"
        :get-b122-table-results-url="'/operationDevis/getB122TableResults?restrictbylong-operationId=' + operationId"
        :identifier="'B122TableDevis'"
        :use-filters="true"
        :use-pagination="false"
        init-b122-table-url="/operationDevis/initB122Table"
        @clickOnDeleteBtn="clickOnDeleteDevisBtn"
        @clickOnEditBtn="clickOnEditDevisBtn"
        @clickOnShowBtn="clickOnShowDevisBtn">

        <template #cell(operationDevis.prixTTC)="data">
          <template v-if="data.value !== ''"> {{ data.value | formatEuro }}</template>
        </template>

        <template #cell(operationDevis.operationConstruction.operationLots)="data">
          <template
            v-if="data.item.operationDevis.operationConstruction && data.item.operationDevis.operationConstruction.operationLots.length === 1">
            {{ data.item.operationDevis.operationConstruction.operationLots[0] }}
          </template>
          <template
            v-else-if="data.item.operationDevis.operationConstruction && data.item.operationDevis.operationConstruction.operationLots.length > 1">
            {{ data.item.operationDevis.operationConstruction.operationLots.length + ' ' + $t('lots') }}
          </template>
          <template
            v-else-if="data.item.operationDevis.operationConstruction && data.item.operationDevis.operationConstruction.operation">
            {{ $t('operation.All.lots.devis') }}
          </template>
          <template
            v-else-if="data.item.operationDevis.operationHonoraire && data.item.operationDevis.operationHonoraire.operationLots.length === 1">
            {{ data.item.operationDevis.operationHonoraire.operationLots[0] }}
          </template>
          <template
            v-else-if="data.item.operationDevis.operationHonoraire && data.item.operationDevis.operationHonoraire.operationLots.length > 1">
            {{ data.item.operationDevis.operationHonoraire.operationLots.length + ' ' + $t('lots') }}
          </template>
          <template v-else>{{ "-" }}</template>
        </template>

        <template #cell(operationDevis.schedule)="data">
          <template v-if="data.item.operationDevis.schedule && data.item.operationDevis.schedule.id ">
            <div v-for="payment in data.item.operationDevis.schedule.paiements " :key="payment.id">
              <div v-if="payment.id">
                {{ formatDate(payment.date) }} :
                {{ payment.amount | formatEuro }}
              </div>
              <div v-else>
                {{ "-" }}
              </div>
            </div>
          </template>
          <template v-else>{{ "-" }}</template>
        </template>

        <template #cell(operationDevis.status)="data">
          <span
            :style="{borderColor: data.item.operationDevis.status.mainColor.toString(), backgroundColor: data.item.operationDevis.status.secondaryColor.toString(), color: data.item.operationDevis.status.textColor ? data.item.operationDevis.status.textColor.toString() : '#000'}"
            class="bold-text main-color-text p-2"
            style="display: inline-block; border: 1px solid; border-radius: 4px;">
            {{ $t(data.item.operationDevis.status.text) }}
          </span>
        </template>

        <template #cell(operationDevis.documents)="data">
          <div v-for="document in data.item.operationDevis.documents" class="row">
            <b-link class="light-blue-color underline-text ml-3 mb-1" v-on:click="getDocument(document.fileUrl)">
              {{ truncateText(document.fileName, 45) }}
            </b-link>
          </div>
        </template>
      </b122-table>
    </b-card>
    <Item-delete-modal
      id="devisDeleteModal"
      :selectedItem="devisToDelete"
      controllerName="operationDevis"
      itemSingularName="devis"
      itemSingularNameUpp="Devis"
      @didDeleteItem="didDeleteDevis()">
    </Item-delete-modal>
  </b-container>
</template>

<script>
import api from '../../services/api'
import BackArrow from "../../components/b122/BackArrow.vue";
import B122Table from "../../components/b122/B122Table";
import ItemDeleteModal from "../../components/b122/ItemDeleteModal";

export default {
  name: "OperationDevisIndex",

  components: {
    BackArrow,
    B122Table,
    ItemDeleteModal
  },

  data() {
    return {
      devisToDelete: {},
      operationName: "",
      bilanType: null,
      operationId: this.$route.params.operationId,
      nbDevis: "-",
      totalTTC: null,
      tableFieldsDevis: [
        {
          label: this.$t('See'),
          key: 'show',
          sortable: false,
        },
        {
          label: this.$t('Lot'),
          key: 'operationDevis.operationConstruction.operationLots',
        },
        {
          label: this.$t('OperationConstruction'),
          key: 'operationDevis.operationConstruction.name',
          sortable: true,
        },
        {
          label: this.$t('OperationHonoraire'),
          key: 'operationDevis.operationHonoraire.type',
          sortable: true,
        },
        {
          label: this.$t("devis.PrixTTC"),
          key: 'operationDevis.prixTTC',
          sortable: true,
        },
        {
          label: this.$t("SchedulePayment"),
          key: 'operationDevis.schedule',
          sortable: false,
        },
        {
          label: this.$t('OperationTask.status'),
          key: 'operationDevis.status',
          sortable: true,
        },
        {
          label: this.$t('ContactDocuments'),
          key: 'operationDevis.documents',
          sortable: false,
        },
        {
          label: '',
          key: 'actions',
        }],
    }
  },

  filters: {
    showOperationOrLot: function (construction) {
      if (construction.operation) {
        return [construction.operation.name];
      } else if (construction.operationLots && construction.operationLots.length > 0) {
        // Retourner directement le tableau
        return construction.operationLots;
      }
      return ['-'];
    }
  },

  async mounted() {
    await this.fetchData()
  },

  methods: {

    clickOnFacturesBtn() {
      this.$router.push({
        name: 'OperationFactureIndex',
        params: {
          operationId: this.operationId,
        }
      })
    },

    clickOnBudgetBtn() {
      this.$router.push({
        name: 'OperationShow',
        params: {
          operationId: this.operationId,
          currentSection: 2,
        }
      })
    },

    async fetchData() {
      await this.getOperation()
      await this.getStatusDevis()
      await this.getCardsData()
    },

    async getStatusDevis() {
      await api
        .get(`/operationDevis/getStatusDevis`)
        .then(response => {
          this.statusDevis = response.data
        })
    },

    async getCardsData() {
      await api
        .get(`/operationDevis/getCardsData/${this.operationId}`)
        .then(response => {
          const {nbDevis, totalTTC} = response.data;
          this.nbDevis = nbDevis;
          this.totalTTC = totalTTC
        });
    },

    getDocument(fileUrl) {
      let url = process.env.SERVER_URL + fileUrl
      window.open(url, '_blank').focus();
    },

    truncateText(filename, maxLength = 30, ellipsis = '...') {
      if (typeof filename !== 'string' || filename.length === 0) return filename;

      const lastDot = filename.lastIndexOf('.');
      let namePart, extPart;


      if (filename.length <= maxLength) return filename;

      if (lastDot > 0 && lastDot < filename.length - 1) {
        namePart = filename.slice(0, lastDot);
        extPart = filename.slice(lastDot); // ".pdf"
      } else {
        namePart = filename;
        extPart = '';
      }

      const reserved = ellipsis.length + extPart.length;
      const allowedNameLen = maxLength - reserved;

      if (allowedNameLen <= 0) {
        const extAllowed = Math.max(0, maxLength - ellipsis.length);
        return ellipsis + extPart.slice(0, extAllowed);
      }

      const truncatedName = namePart.slice(0, allowedNameLen);
      return truncatedName + ellipsis + extPart;
    },

    clickOnShowDevisBtn(row) {
      this.$router.push({
        name: 'OperationDevisShow',
        params: {
          operationDevisId: row.item.operationDevis.id,
          operationId: this.operationId,
        }
      })
    },

    clickOnEditDevisBtn(row) {
      this.$router.push({
        name: 'OperationDevisEdit',
        params: {
          operationDevisId: row.item.operationDevis.id,
          operationId: this.operationId
        }
      })
    },

    clickOnDeleteDevisBtn(row) {
      this.devisToDelete = row.item.operationDevis
      if (this.devisToDelete && this.devisToDelete.schedule && this.devisToDelete.schedule.paiements.some(payment => payment.facture)) {
        this.$alert(this.$i18n.t('devis.cant.delete.facture.linked').toString()).then(() => {
        });
      } else {
        this.$bvModal.show('devisDeleteModal')
      }
    },

    didDeleteDevis() {
      this.successToast((this.$i18n.t('Devis')) + ' "' + this.devisToDelete.numero + '" ' + this.$i18n.t('deleted'))
      this.$refs.B122TableDevis.refreshTable()
      this.devisToDelete = null
    },

    successToast(message) {
      this.$bvToast.toast(message, {
        autoHideDelay: 20000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true,
        variant: 'success',
        solid: true,
      })
    },

    async getOperation() {
      if (this.operationId != null) {
        await api
          .get(`/operation/${this.operationId}`)
          .then(response => {
            this.operationName = response.data.name
            this.bilanType = response.data.bilanType
          })
      }
    },

    formatDate(dateString) {
      return new Date(dateString).toLocaleDateString()
    },
  }
}
</script>

<style scoped>
.backtotal {
  padding: 0 !important;
  color: var(--main-white);
  border-radius: 0 !important;
}

.backtotal > .card-body {
  padding: 0.25rem !important;
}
</style>



// WEBPACK FOOTER //
// src/views/operationDevis/OperationDevisIndex.vue